<!--
 * @message: 列表顶部筛选组件侧边筛选-更多
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-03-29 10:08:21
 * @FilePath: \mrc-ess-fronted\src\components\MRC_ESS_List_Selections\Right_Selection.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-12-07 18:24:31
-->
<template>
  <v-navigation-drawer
    v-model="drawer"
    width="340"
    right
    @input="onChange"
    temporary
    fixed
    :overlay-opacity="0"
  >
    <v-container
      fluid
      class="
        max-width
        fill-height
        ma-0
        pa-0
        d-flex
        flex-column
        justify-space-between
      "
    >
      <v-toolbar
        flat
        dense
        class="pr-3"
        style="width: 100%"
        color="primary"
        height="56"
      >
        <v-toolbar-title class="text-subtitle-2 white--text">
          {{ $t("message_essweb_system_list_filter_AdvancedFilterTip") }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attr }">
            <v-btn
              icon
              v-on="on"
              @click.stop="closeDialog"
              v-bind="attr"
              color="white"
              small
            >
              <span class="material-icons-round">close</span>
            </v-btn>
          </template>
          <span>{{
            $t("label_essweb_RosterFormRecord_form_slide_closeBtnTip")
          }}</span>
        </v-tooltip>
      </v-toolbar>
      <v-container
        fluid
        class="ma-0 pa-3 d-flex flex-column scroll_content_y"
        :style="{ height: $vuetify.breakpoint.height - 57 - 57 + 'px' }"
      >
        <v-form lazy-validation ref="form">
          <v-row>
            <v-col
              :cols="12"
              :lg="12"
              :xl="12"
              :xs="12"
              :md="12"
              :sm="12"
              v-show="item.position == 'right' || item.position == 'top'"
              v-for="(item, index) in ObjectsCopy"
              :key="`filters---${index}`"
            >
              <slot :item="item" :index="index" :name="item.name" />
            </v-col> </v-row
        ></v-form>
      </v-container>

      <v-divider style="width: 100%; height: 1px"></v-divider>
      <v-sheet
        height="56"
        class="align-center transparent text-center d-flex justify-center"
      >
        <v-btn
          color="primary"
          rounded
          text
          height="32"
          class="pl-7 pr-7 text-capitalize mx-4"
          @click="
            $refs['form'].reset();
            $emit('clear');
            $emit('close');
          "
          >{{ $t("label_essweb_system_list_filter_resetBtnLabel") }}</v-btn
        >
        <!--label_essweb_form_tools_cancelBtnLabel-->
        <v-btn
          color="primary"
          rounded
          height="32"
          :loading="isLoading"
          class="pl-7 pr-7 text-capitalize mx-4"
          :disabled="isLoading || !canApply"
          @click="$emit('submit')"
          >{{ $t("label_essweb_system_list_filter_applyBtnLabel") }}</v-btn
        >
      </v-sheet>
    </v-container>
  </v-navigation-drawer>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "Right_Selection",
  computed: {
    ...mapGetters(["companyLang", "staticZone", "isLoading"]),
    ObjectsCopy() {
      //排序
      let arr1 = this.objects.filter((ele) => ele["sequence"] === undefined);
      let arr2 = this.objects.filter((ele) => ele["sequence"] !== undefined);
      return arr2
        .sort((a, b) => {
          return Number(a["sequence"]) < Number(b["sequence"]) ? -1 : 1;
        })
        .concat(arr1);
    },
  },
  props: {
    objects: { default: [], type: [Array, Object] },
    show: { default: true, type: [Boolean, Number] },
  },
  watch: {
    show(val) {
      this.drawer = val;
    },
    objects: {
      handler(val) {
        if (this.$refs["form"] && !this.$refs["form"].validate()) {
          this.canApply = false;
        } else {
          this.canApply = true;
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      drawer: false,
      canApply: true,
    };
  },
  methods: {
    closeDialog: function () {
      this.$emit("close");
    },
    onChange() {
      this.$emit("onChange");
    },
  },
};
</script>
<style >
.v-slide-group__wrapper {
  /* 强制修改,使tab filter aslide 显示在app */
  contain: none !important;
}
</style>